import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Inicio from './components/Inicio';
import NuestraEmpresa from './components/NuestraEmpresa';
import Servicios from './components/Servicios';
import Contacto from './components/Contacto';
import Request2 from './components/Request2';
import ScrollToTop from './components/ScrollToTop';
import Investigaciones from './components/Investigaciones';
import ArmatControl from './components/ArmatControlLanding'


function App() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const targetElement = document.querySelector(location.hash);
        if (targetElement) {
          const headerHeight = document.querySelector('header')?.offsetHeight || 0;
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: "auto",
          });
        }
      }, 1000); 
    }
  }, [location]);
  

  return (
    <>
      <ScrollToTop/>
      <Header/>
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/Nosotros" element={<NuestraEmpresa />} />
        <Route path="/Servicios" element={<Servicios />} />
        <Route path="/Servicios#dispositivos" element={<Servicios />} />
        <Route path="/Servicios#barrio-cerrado" element={<Servicios />} />
        <Route path="/Servicios#comercios" element={<Servicios />} />
        <Route path="/Investigaciones" element={<Investigaciones />} />
        <Route path="/ArmatControl" element={<ArmatControl />} />
        <Route path="/Contacto" element={<Contacto />} />
      </Routes>
      <Request2/>
      <Footer />    
    </>
  );
}

export default App;
